import React from 'react';

const AppointmentCall = (props) => {
    return (
        <div className="appointment-call">
            <div className="b-content">
                <header className="b-header">
                    SCHEDULE APPOINTMENT
                </header>

                <div className="centered-section">
                    <img className="main-icon"
                        src="/images/appointment/icon-call.svg"
                    />
                    <h3 className="step-title">
                        <a href={`tel:${props.center.phoneNumber}`}>
                            {props.center.phoneNumber}
                        </a>
                    </h3>

                    <h4 className="subtitle">
                        Please call us
                        <br/>
                        to schedule your appointment
                    </h4>

                    <a className="apply-btn alert-btn"
                        href={`tel:${props.center.phoneNumber}`} >
                        CALL US NOW
                    </a>
                </div>
            </div>
        </div>
    );
};

export default AppointmentCall;


// WEBPACK FOOTER //
// ./Src/Appointment/AppointmentCall/AppointmentCall.jsx